import {
  QuestionAnswerMap
} from '@care-portals/api-interfaces';

const ldnQuestions = [
  {
    class: 'ineligible',
    field: 'ldn_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    blockQuestionFlow: true,
    answer: {},
    extras: { sendToBeluga: false }
  },
  {
    field: 'ldn_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'ldn_sexAssignedAtBirth',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'ldn_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'Consent (Pregnancy Risk):',
    educationalSlide: `I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.
I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.
I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.
By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
    field: 'ldn_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and do NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'ldn_height',
    type: 'info',
    answer: {
      type: 'text',
      name: 'ldn_height',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'ldn_weight',
    type: 'info',
    answer: {
      type: 'text',
      name: 'ldn_weight',
      placeholder: 'Pounds'
    }
  },
  {
    label:
      'This visit type is specifically for the use of low dose naltrexone (LDN) in the treatment of chronic pain (over 12 weeks duration) which has been evaluated by a medical doctor.  This encounter is NOT intended to be used for treatment of sudden onset (acute) pain without an understanding of what is causing the pain.  Sudden pain should be evaluated immediately by your provider to assess the etiology of your symptoms.',
    field: 'ldn_chronicPainAcknowledgment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have chronic pain which has been evaluated by my doctor',
          key: 'chronic'
        },
        {
          value:
            "I have acute pain and/or I do NOT know the cause of my pain",
          key: 'acute_or_unknown'
        }
      ]
    }
  },
  {
    label: 'Please describe your primary inflammatory symptoms (select all that apply).',
    field: 'ldn_primaryInflammatorySymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Joint pain', key: 'joint_pain' },
        { value: 'Muscle aches', key: 'muscle_aches' },
        { value: 'Digestive issues', key: 'digestive_issues' },
        { value: 'Skin rashes', key: 'skin_rashes' },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    label: 'Please provide more information about your symptoms',
    field: 'ldn_primaryInflammatorySymptomsOther',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ldn_primaryInflammatorySymptomsOther'
    }
  },
  {
    label: 'When did you first notice these symptoms?',
    field: 'ldn_symptomsOnset',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 12 weeks', key: 'less_12_weeks' },
        { value: '12-52 weeks', key: '12_52_weeks' },
        { value: '1-3 years', key: '1_3_years' },
        { value: 'Over 3 years', key: 'over_3_years' }
      ]
    }
  },
  {
    label:
      'Have you been diagnosed with any inflammatory condition(s)? (select all that apply)',
    field: 'ldn_inflammatoryConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Rheumatoid arthritis', key: 'rheumatoid_arthritis' },
        { value: "Crohn's disease", key: 'crohns_disease' },
        { value: 'Hashimoto\'s thyroiditis', key: 'hashimotos' },
        { value: 'Fibromyalgia', key: 'fibromyalgia' },
        { value: 'Other', key: 'other' },
        {
          value: 'I do not have any of these conditions',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Please provide more information about your inflammatory condition',
    field: 'ldn_inflammatoryConditionsOther',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ldn_inflammatoryConditionsOther'
    }
  },
  {
    label:
      'Are you aware of any triggers or known causes of your inflammation? (select all that apply)',
    field: 'ldn_inflammationTriggers',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Autoimmune disease', key: 'autoimmune' },
        { value: 'Chronic infection', key: 'chronic_infection' },
        { value: 'Allergy', key: 'allergy' },
        { value: 'Dietary factors', key: 'dietary' },
        { value: 'Environmental exposures', key: 'environmental' },
        { value: 'Other', key: 'other' },
        { value: "I don't know of any triggers", key: 'dont_know', uncheckOthers: true }
      ]
    }
  },
  {
    label: 'Please provide more information about your inflammatory trigger',
    field: 'ldn_inflammationTriggersOther',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ldn_inflammationTriggersOther'
    }
  },
  {
    label:
      'What treatments (medications, supplements, therapies) have you tried for this inflammatory condition, and what were the results?',
    field: 'ldn_treatmentsTried',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ldn_treatmentsTried'
    }
  },
  {
    label:
      'Have you ever taken naltrexone or low-dose naltrexone (LDN) before? If yes, when and what was your experience?',
    field: 'ldn_takenNaltrexoneBefore',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'Did you respond well to Naltrexone?',
    field: 'ldn_respondedWellToNaltrexone',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'Did you experience side effects to naltrexone?',
    field: 'ldn_sideEffectsToNaltrexone',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'Tell us more about your side effects to naltrexone',
    field: 'ldn_sideEffectsToNaltrexoneDetails',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ldn_sideEffectsToNaltrexoneDetails'
    }
  },
  {
    label:
      'Are you currently taking any opioid medications (e.g., morphine, hydrocodone, oxycodone)?',
    field: 'ldn_currentOpioids',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Do you have a history of opioid use disorder or have you ever been in a treatment program for opioid dependence?',
    field: 'ldn_opioidUseDisorder',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Do you have known liver cirrhosis, liver inflammation (elevated liver enzymes) or chronic kidney disease stage 4 or higher?',
    field: 'ldn_liverKidneyDisease',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Do you have a history of severe depression, bipolar disorder, or other significant mental health conditions?',
    field: 'ldn_mentalHealthHistory',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'ldn_additionalInfo',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ldn_additionalInfo'
    }
  },
  {
    label: 'Consent (Truthfulness):',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.

Consent: I verify that I am the patient and that I have answered the questions asked in this intake form.  I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    field: 'ldn_truthfulnessConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label: 'Consent: Purpose of LDN Therapy',
    educationalSlide: `Purpose of LDN Therapy:
Low Dose Naltrexone (LDN) is prescribed off-label for certain inflammatory conditions. It may help modulate the immune system and reduce inflammation. LDN is approved by the FDA at higher doses for opioid and alcohol dependence, but use at low doses for inflammation is considered off-label.

Expected Benefits and Risks:
- Potential Benefits: May include reduction in inflammation, decrease in pain, improvement in energy levels, and overall better quality of life.
- Possible Side Effects: Sleep disturbances, vivid dreams, mild headaches, gastrointestinal upset, and potential temporary changes in mood.
- Long-Term Risks: Not fully established; studies are ongoing. Known risks at low doses are generally mild, but there is limited long-term data.

Off-Label Use:
I understand that LDN is not FDA-approved for treating inflammation.

Contraindications and Precautions:
I have disclosed all current medications and medical conditions. I understand that LDN may not be safe if I am taking opioids, if I have certain medical conditions, or if I become pregnant.

Follow-Up and Monitoring:
I agree to follow the treatment plan and attend follow-up appointments as recommended by my healthcare provider. I will report any new symptoms or side effects promptly.

Voluntary Participation:
I understand that I may choose to discontinue LDN therapy at any time. My decision to participate is voluntary and based on a full understanding of the potential benefits and risks.

By selecting below, you confirm that you:
- Have read and understood the information provided
- Understand the potential risks and benefits of using low dose naltrexone, as well as its off-label nature
- Agree to adhere to the monitoring plan and report any concerns or side effects to your healthcare provider`,
    field: 'ldn_therapyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the consent and I do NOT wish to move forward',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'I have read the consent and understand the content, I wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  }
] as const;

export type LDNQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof ldnQuestions>
>;
export default ldnQuestions;
